import * as React from 'react';
import { observer } from 'mobx-react-lite';

import { FilterProps } from '../../../components/srp/sort-filter/checkbox';
import { rangeCheckboxClickHandler } from '../../../components/srp/sort-filter/range-filter-helper';

import { ActivityDestinationViewSearch } from '../../../common/__generated__/api';
import { CheckboxTracked } from '../../../utils/click-trackers';
import { useStores } from '../../../utils/hooks';
import Options = ActivityDestinationViewSearch.Options;

export const RangeCheckbox: React.FC<FilterProps> = observer(({ inDialog, field }) => {
  const { activitySearchStore, routeStore } = useStores();
  const categoryName = field.label || undefined;
  const categoryId = field.id;
  const filterOptions = activitySearchStore.sortAndFilterObject.filters;

  const updateRangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>): void => {
    rangeCheckboxClickHandler(activitySearchStore, routeStore, event, inDialog);
  };

  return (
    <>
      <fieldset key={categoryName}>
        {categoryName ? (
          <legend
            className="all-t-padding-four all-b-padding-two uitk-type-heading-400 uitk-type-bold"
            data-testid="filter--category-name"
          >
            {categoryName}
          </legend>
        ) : null}
        {(field as ActivityDestinationViewSearch.ActivitySelectionFieldInlineFragment).options.map(
          (option: Options) => (
            <div key={`parent-category-${option.value}`} data-testid={`filter--${categoryId}-options`}>
              <CheckboxTracked
                id={`cb-${option.value}-${categoryId}`}
                label={option.primary}
                value={filterOptions[categoryId][option.value].selected}
                checked={filterOptions[categoryId][option.value].selected}
                disabled={!filterOptions[categoryId][option.value].enabled}
                onChange={updateRangeCheckbox}
                rfrr={
                  option.analytics?.referrerId ||
                  (filterOptions[option.value] ? 'LX.SR.FO.Category' : `LX.SR.filterSort.Category.${option.value}`)
                }
                linkName={option.analytics?.linkName}
                data-testid={`filter--${categoryId}-options-checkbox`}
              />
            </div>
          )
        )}
      </fieldset>
    </>
  );
});
